import store from '@/store'
import {
  connectionService,
  RACE_TIMEOUT,
  THING_FIND_URI
} from '@leapsight/styleguide'
export default {
  PROMISE_STATUS: Object.freeze({
    rejected: 'rejected',
    fulfilled: 'fulfilled'
  }),
  getEntities({ page = 1, connection = null, things = [], retries = 0 } = {}) {
    return new Promise((resolve, reject) => {
      this.entitiesFind(page, connection)
        .then(response => {
          things = things?.concat(response?.args[0])
          if (response?.args[0].length < 200) {
            resolve(things)
          } else {
            page++
            this.getEntities({ page, connection, things })
              .then(response => {
                resolve(response)
              })
              .catch(error => {
                reject(error)
              })
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  entitiesFind(page, connectionParam) {
    const p1 = new Promise(reject => {
      setTimeout(reject, RACE_TIMEOUT, false)
    })

    const p2 = new Promise((resolve, reject) => {
      const connection = store.getters['authState/connection']
        ? store.getters['authState/connection']
        : connectionParam
      const args = [connectionService.getAccountId()]
      const kwArgs = connectionService.createkwArgs()
      const options = {}
      kwArgs.types = ['mrn:thing:vehicle', 'mrn:thing:flex']
      kwArgs.query_spec = {
        _p: 'config.services',
        _page: page,
        _limit: 200
      }
      connection?.session.call(THING_FIND_URI, args, kwArgs, options).then(
        response => {
          resolve(response)
        },
        wampError => {
          reject(wampError)
        }
      )
    })

    return Promise.race([p1, p2])
      .then(value => {
        return value
      })
      .catch(error => {
        return error
      })
  },
  async connectToMaintenanceService(connectionParam) {
    // connectionParam is used in cases where this function is called outside of the established connection's scope
    // (i.e: from the ToolbarAppBox component in the Fleet Management module)
    const countryId = localStorage.getItem('country_id')
    const MAINTENANCE_SERVICE_FLEET_URI =
      countryId === 'ar'
        ? 'https://strix.com.ar/landings/mantenimiento-de-flotas'
        : countryId === 'cl'
        ? 'https://strix.cl/landings/mantenimiento-de-flotas'
        : 'https://strix.uy/landings/mantenimiento-de-flotas'

    const connection = store.getters['authState/connection']
      ? store.getters['authState/connection']
      : connectionParam
    const entities = await this.getEntities({ connection })

    const hasArflotaService =
      Array.isArray(entities) &&
      entities.some(entity => entity.config?.services?.['mrn:service:arflota'])

    const p1 = new Promise(reject => {
      setTimeout(reject, RACE_TIMEOUT, false)
    })

    const p2 = new Promise((resolve, reject) => {
      const kwArgs = connectionService.createkwArgs()
      if (hasArflotaService) {
        connection?.session
          .call(
            'com.magenta.connected_accounts.get_link',
            ['mrn:service:arflota'],
            kwArgs,
            {}
          )
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
          .catch(err => {
            console.log(err)
          })
      } else {
        resolve(MAINTENANCE_SERVICE_FLEET_URI)
      }
    })

    return Promise.race([p1, p2])
      .then(value => {
        return value
      })
      .catch(error => {
        return error
      })
  }
}
